/// <reference path="../../types/window.d.ts" />

/**
 * Tealium startup invariants that MUST be true before the app runs.
 * These are checked once at module load time, not at runtime.
 */

const UTAG_DATA_MISSING_ERROR =
  '❌❌❌ CRITICAL [Tealium]: window.utag_data is not defined!\n' +
  '   This MUST be defined in index.html BEFORE React loads.\n' +
  '   Check that the <script> tag defining utag_data is present and executed.';

/**
 * Helper to handle dev vs prod errors consistently.
 * @param {string} message
 */
function failInDevWarnInProd(message) {
  if (process.env.NODE_ENV === 'development') {
    throw new Error(message);
  }
  console.error(message);
}

/**
 * Validates that window.utag_data exists.
 * Called once at module load time.
 */
function validateUtagDataExists() {
  if (
    typeof window !== 'undefined' &&
    (typeof window.utag_data !== 'object' || window.utag_data === null)
  ) {
    failInDevWarnInProd(UTAG_DATA_MISSING_ERROR);
  }
}

/**
 * Asserts that window.utag_data exists.
 * Use this before mutating utag_data.
 */
export function assertUtagDataExists() {
  if (
    typeof window === 'undefined' ||
    typeof window.utag_data !== 'object' ||
    window.utag_data === null
  ) {
    failInDevWarnInProd(UTAG_DATA_MISSING_ERROR);
    return false;
  }
  return true;
}

// Run validation immediately when this module loads
validateUtagDataExists();
